<template>
  <el-dialog 
    :title="$t('address.addAddress')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item :label="$t('address.receiver')" prop="username">
        <el-input v-model="form.username" maxlength="20"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('address.phone')" prop="tel">
        <el-input v-model="form.tel" maxlength="11"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('address.region')" prop="areaName">
        <el-select 
          v-model="form.selectProv" 
          @change="getProv(form.selectProv)"
          style="width: 30%; margin-right: 3%"
          :placeholder="$t('address.selectProvince')"
        >
          <el-option
            v-for="item in provs"
            :key="item.areaCode"
            :label="item.areaName"
            :value="item.areaCode"
          ></el-option>
        </el-select>
        
        <el-select 
          v-model="form.selectCity"
          @change="getCity(form.selectCity)"
          style="width: 30%; margin-right: 3%"
          :placeholder="$t('address.selectCity')"
        >
          <el-option
            v-for="item in citys"
            :key="item.areaCode"
            :label="item.areaName"
            :value="item.areaCode"
          ></el-option>
        </el-select>
        
        <el-select 
          v-model="form.selectArea"
          @change="getArea(form.selectArea)"
          style="width: 30%"
          :placeholder="$t('address.selectDistrict')"
        >
          <el-option
            v-for="item in areas"
            :key="item.areaCode"
            :label="item.areaName"
            :value="item.areaCode"
          ></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item :label="$t('address.detailAddress')" prop="address">
        <el-input v-model="form.address" maxlength="30"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('address.postalCode')">
        <el-input v-model="form.postalCode" maxlength="6"></el-input>
      </el-form-item>
      
      <el-form-item>
        <el-checkbox v-model="form.isDefault">{{ $t('address.setDefault') }}</el-checkbox>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveAddress">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveUserAddress, listAreas } from '@/api/plateform/addressApi'

export default {
  name: 'AddressDialog',
  props: {
    provs: Array,
    citys: Array,
    areas: Array
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        selectProv: '',
        selectCity: '',
        selectArea: '',
        addressId: '',
        userId: '',
        area: '',
        address: '',
        areaCode: '',
        province: '',
        city: '',
        postalCode: '',
        district: '',
        telNum: '',
        areaName: '',
        extensionNum: '',
        tel: '',
        zipCode: '',
        isDefault: false,
        createUser: '',
        createOrg: '',
        updateUser: '',
        updateOrg: '',
        provinceStr: '',
        cityStr: '',
        districtStr: '',
      },
      rules: {
        username: [
          { required: true, message: this.$t('address.receiverRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('address.receiverMaxLength'), trigger: 'blur' }
        ],
        tel: [
          { required: true, message: this.$t('address.phoneRequired'), trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t('address.phoneFormat'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('address.detailAddressRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('address.detailAddressMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.resetForm()
    },
    resetForm() {
      this.form = {
        selectProv: '',
        selectCity: '',
        selectArea: '',
        addressId: '',
        userId: this.$store.getters.userId,
        area: '',
        address: '',
        areaCode: '',
        province: '',
        city: '',
        postalCode: '',
        district: '',
        telNum: '',
        areaName: '',
        extensionNum: '',
        tel: '',
        zipCode: '',
        isDefault: false,
        createUser: '',
        createOrg: '',
        updateUser: '',
        updateOrg: '',
        provinceStr: '',
        cityStr: '',
        districtStr: '',
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    async getProv(prov) {
      try {
        const res = await listAreas({
          areaLevel: '202',
          parentAreaCode: prov
        })
        this.$emit('update:citys', res.data)
      } catch (error) {
        console.error('获取城市数据失败:', error)
      }
    },
    async getCity(city) {
      try {
        const res = await listAreas({
          areaLevel: '303',
          parentAreaCode: city
        })
        this.$emit('update:areas', res.data)
      } catch (error) {
        console.error('获取区县数据失败:', error)
      }
    },
    getArea(area) {
      this.form.areaName = ''
      this.form.areaCode = area
      
      if (this.provs) {
        const prov = this.provs.find(item => item.areaCode === this.form.selectProv)
        if (prov) this.form.areaName += prov.areaName
      }
      
      if (this.citys) {
        const city = this.citys.find(item => item.areaCode === this.form.selectCity)
        if (city) this.form.areaName += city.areaName
      }
      
      if (this.areas) {
        const area = this.areas.find(item => item.areaCode === this.form.selectArea)
        if (area) this.form.areaName += area.areaName
      }
    },
    async saveAddress() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const params = {
              ...this.form,
              isDefault: this.form.isDefault ? '1' : '0'
            }
            await saveUserAddress(params)
            this.$message.success(this.$t('address.saveSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error('保存地址失败:', error)
          }
        }
      })
    }
  }
}
</script>